import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CardGatewayPaymentClassificationResponse {
  /**
   * Payment template ID.
Null if the payment is classified as reversal or not classified yet.
   */
  @observable
  paymentTemplateId?: string;

  /**
   * Payment is reversal.
   */
  @observable
  isReversal!: boolean;
}
